<div *ngIf="(auth.isLoading$ | async) === false; else loading">
    <div *ngIf="isAuthenticated; else loggedOut">
        <div *ngIf="(isSetupComplete && !isLoading) || sharedService.AccessDenied; else loader">
            <div *ngIf="!sharedService.AccessDenied" class="app-header">
                <app-header></app-header>
            </div>
            @if (inSystemAdminMode) {
                <app-admin-banner></app-admin-banner>
            }
            <router-outlet></router-outlet>
        </div>

        <ng-template #loader>
            <app-loading-page [message]="'Loading your data'"></app-loading-page>
        </ng-template>
    </div>

    <ng-template #loggedOut>
        <app-landing-page></app-landing-page>
    </ng-template>
</div>

<ng-template #loading>
    <!-- Optionally, display a full-page loading spinner here -->
    <app-loading-page [message]="'Checking authentication...'" ></app-loading-page>
</ng-template>

<app-style-guide></app-style-guide>


<!-- Dedicated Kendo Dialog Container -->
<div kendoDialogContainer></div>